import { observer } from 'mobx-react'
import React from 'react'

import { UserPIN } from '@flowwai-frontend/shared-web/iam/data-access'
import { UserPINUpdateMode } from '@flowwai-frontend/shared-web/iam/ui'
import { ReactBaseModalContainerV2 } from '@flowwai-frontend/shared/common-components'

import UserPINUpdateController from '../../controllers/UserPINUpdateController/UserPINUpdateController'
import { useUserAppConfigStore } from '../../hooks/stores/useUserAppConfigStore'

interface Props {
   userPIN: UserPIN | null
   setUserPIN: (userPIN: UserPIN) => void
   isModalOpen: boolean
   onCloseModal: () => void
}

const UserPINUpdateModal = (props: Props): React.ReactElement => {
   const { userPIN, isModalOpen, onCloseModal } = props

   const { userDetails } = useUserAppConfigStore()

   if (!userDetails) throw new Error('User details not found')

   const mode: UserPINUpdateMode = userPIN?.isPINConfigured
      ? 'RESET_PIN'
      : 'NEW_PIN'

   const renderUI = (): React.ReactElement => (
      <UserPINUpdateController
         mode={mode}
         onCloseModal={onCloseModal}
         userDetails={userDetails}
         onUpdatePIN={props.setUserPIN}
      />
   )

   return (
      <ReactBaseModalContainerV2
         onClickClose={onCloseModal}
         isModalOpen={isModalOpen}
         renderUI={renderUI}
         containerClassName='!h-fit !w-[498px] flex justify-center gap-5 items-start'
         overlayContainerClassName={'!z-50'}
         closeIconClassName={'relative'}
      />
   )
}

export default observer(UserPINUpdateModal)
